import { render, staticRenderFns } from "./LensIcon.vue?vue&type=template&id=a11a3486&scoped=true"
import script from "./LensIcon.vue?vue&type=script&lang=js"
export * from "./LensIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11a3486",
  null
  
)

export default component.exports